import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20scene%20with%20carefully%20curated%20clothing%20items%20in%20warm%20terracotta%20camel%20and%20cream%20tones%20artfully%20arranged%20on%20a%20light%20oak%20surface%2C%20soft%20natural%20sunlight%20streaming%20through%20sheer%20curtains%2C%20minimal%20editorial%20composition%20with%20organic%20textures%2C%20warm%20inviting%20atmosphere%2C%20fashion%20styling%20photography%20with%20harmonious%20neutral%20palette&width=1800&height=1200&seq=hero-bg-v2-001&orientation=landscape"
          alt="LitBuy Spreadsheet Hub fashion lifestyle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-20">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-6 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left lg:pt-16">
            <p className="text-xs md:text-sm font-label uppercase tracking-[0.2em] text-background-50/80 mb-4">
              Your Ultimate Resource Hub
            </p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.05]">
              The Ultimate
              <br />
              LitBuy Spreadsheet
              <br />
              Hub
            </h1>
            <p className="mt-5 text-sm md:text-base text-background-50/70 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Discover comprehensive guides, templates, and resources to master your litbuy spreadsheet workflow. 
              Learn how to organize, track, and optimize your buying experience with expert-curated content.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3 bg-primary-500 text-background-50 rounded-full font-label font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                litbuy spreadsheet
                <span className="w-4 h-4 inline-flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3 border-2 border-background-50/60 text-background-50 rounded-full font-label font-semibold text-sm hover:bg-background-50 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
              >
                buy it now
              </a>
            </div>
          </div>

          <div className="hidden lg:block flex-1">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Luxurious%20cashmere%20sweater%20in%20warm%20camel%20tone%20draped%20elegantly%20over%20a%20minimal%20wooden%20chair%2C%20soft%20natural%20light%20from%20nearby%20window%20creating%20gentle%20highlights%2C%20cream%20wall%20background%2C%20refined%20editorial%20fashion%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20neutral%20aesthetic%20with%20organic%20texture&width=800&height=1000&seq=hero-side-v2-001&orientation=portrait"
                alt="LitBuy fashion style"
                className="w-full max-w-md rounded-3xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-background-50/50 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-background-50/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}